import { getGlobalFontRatio } from './getGlobalFontRatio';
import { FONT_SIZE_BASE, FONT_SIZE_BASE_ALT } from '../theme/constants';
export const scaleWithFont = (value, useAlternativeScale = false) => value *
    getGlobalFontRatio(useAlternativeScale ? FONT_SIZE_BASE_ALT : FONT_SIZE_BASE);
//# sourceMappingURL=scaleWithFont.js.map